<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 16V8H7.2V16H6ZM14.8 15.2L13.95 14.35L15.7 12.6H8.4V11.4H15.7L13.95 9.65L14.8 8.8L18 12L14.8 15.2Z"
      fill="#383838"
    />
  </svg>
</template>
